<form [formGroup]="addressForm()" novalidate>
    <ap-input
        [label]="'foreignAddress.line1.label' | apContent"
        data-bb="foreign-address__line1"
        formControlName="line1"
        autocomplete="section-foreign-address address-line1"
        [messages]="errorMessages"
    >
    </ap-input>

    <ap-input
        [label]="'foreignAddress.line2.label' | apContent"
        data-bb="foreign-address__line2"
        formControlName="line2"
        autocomplete="section-foreign-address address-line2"
        [messages]="errorMessages"
    >
    </ap-input>

    <ap-input
        [label]="'foreignAddress.line3.label' | apContent"
        data-bb="foreign-address__line3"
        formControlName="line3"
        autocomplete="section-foreign-address address-line3"
        [messages]="errorMessages"
    >
    </ap-input>

    <ap-dropdown
        [label]="'foreignAddress.country.label' | apContent"
        data-bb="foreign-address__country"
        formControlName="country"
        autocomplete="section-foreign-address country"
        [options]="countryNames()"
        [messages]="countryErrorMessages"
    >
    </ap-dropdown>
</form>
